import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Products from "./components/Products";
import Rentals from "./components/Rentals";
import InstagramGallery from "./components/InstagramGallery";
import Workshops from "./components/Workshops";
import Knowledge from "./components/Knowledge";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Hero />
        <AboutUs />
        <Products />
        <Rentals />
        <InstagramGallery />
        <Workshops />
        <Knowledge />
        <Contact />
        <Footer />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
